module.exports = __webpack_public_path__ + "img/group25@2x-繁体.5363c759.png";